import React from "react";
import ReportResultsTable from "../shared/ReportResultsTable";

function SoldPoliciesReportBuilder({
  carriers,
  carriersLoading,
  coverageTypes,
  coverageTypesLoading,
  agents,
  agentsLoading,
  filters,
  setFilters,
  reportResults,
  builtConfig,
  formatFieldName
}) {
  const currentMonthRange = React.useMemo(() => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1)
      .toISOString()
      .slice(0, 10);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0)
      .toISOString()
      .slice(0, 10);

    return { start, end };
  }, []);

  const updateFilter = (field, value, value2 = "") => {
    setFilters((prev) => {
      const next = [...prev];
      const index = next.findIndex((item) => item.field === field);

      if (
        value === "" ||
        value == null ||
        (field === "effective_date" && !value && !value2)
      ) {
        if (index >= 0) next.splice(index, 1);
        return next;
      }

      const filter =
        field === "effective_date"
          ? {
              field,
              operator: "between",
              value,
              value2
            }
          : {
              field,
              operator: "equals",
              value,
              value2: ""
            };

      if (index >= 0) {
        next[index] = filter;
      } else {
        next.push(filter);
      }

      return next;
    });
  };

  const getFilterValue = (field) => {
    const found = filters.find((item) => item.field === field);
    return found?.value || "";
  };

  const getFilterValue2 = (field) => {
    const found = filters.find((item) => item.field === field);
    return found?.value2 || "";
  };

  const handleClearFilters = () => {
    setFilters([
      {
        field: "effective_date",
        operator: "between",
        value: currentMonthRange.start,
        value2: currentMonthRange.end
      }
    ]);
  };

  const selectedColumns = reportResults?.selectedColumns || builtConfig.selectedColumns || [];
  const rows = reportResults?.rows || [];
  const subtitle = reportResults
    ? `${reportResults.rowCount} row${reportResults.rowCount === 1 ? "" : "s"}`
    : "Run the report to view sold policies";

  const toolbar = (
    <div className="sales-toolbar-card" style={{ marginBottom: "14px" }}>
      <div
        style={{
          display: "flex",
          gap: "10px",
          flexWrap: "wrap",
          alignItems: "center"
        }}
      >
        <input
          type="date"
          className="sales-search-input"
          value={getFilterValue("effective_date")}
          onChange={(e) =>
            updateFilter(
              "effective_date",
              e.target.value,
              getFilterValue2("effective_date") || currentMonthRange.end
            )
          }
          style={{ maxWidth: "170px" }}
        />

        <input
          type="date"
          className="sales-search-input"
          value={getFilterValue2("effective_date")}
          onChange={(e) =>
            updateFilter(
              "effective_date",
              getFilterValue("effective_date") || currentMonthRange.start,
              e.target.value
            )
          }
          style={{ maxWidth: "170px" }}
        />

        <select
          value={getFilterValue("carrier_id")}
          onChange={(e) => updateFilter("carrier_id", e.target.value)}
          className="sales-search-input"
          disabled={carriersLoading}
          style={{ maxWidth: "220px" }}
        >
          <option value="">All Carriers</option>
          {carriers.map((carrier) => (
            <option key={carrier.id} value={carrier.id}>
              {carrier.name || carrier.carrier_name}
            </option>
          ))}
        </select>

        <select
          value={getFilterValue("coverage_type_id")}
          onChange={(e) => updateFilter("coverage_type_id", e.target.value)}
          className="sales-search-input"
          disabled={coverageTypesLoading}
          style={{ maxWidth: "220px" }}
        >
          <option value="">All Coverage Types</option>
          {coverageTypes.map((coverageType) => (
            <option key={coverageType.id} value={coverageType.id}>
              {coverageType.name}
            </option>
          ))}
        </select>

        <select
          value={getFilterValue("aor_user_id")}
          onChange={(e) => updateFilter("aor_user_id", e.target.value)}
          className="sales-search-input"
          disabled={agentsLoading}
          style={{ maxWidth: "220px" }}
        >
          <option value="">All Agents</option>
          {agents.map((agent) => (
            <option key={agent.id} value={agent.id}>
              {agent.name}
            </option>
          ))}
        </select>

        <button
          type="button"
          className="sales-secondary-btn"
          onClick={handleClearFilters}
        >
          Clear Filters
        </button>
      </div>
    </div>
  );

  return (
    <>
      <div className="sales-section-card">
        <div className="sales-section-head">
          <h2>Sold Policies Criteria</h2>
          <p>
            Review policies with Pending/Submitted status using effective date, carrier, coverage type, and agent filters.
          </p>
        </div>
      </div>

      <div style={{ marginTop: "10px" }}>
        <ReportResultsTable
          title="Report Results"
          subtitle={subtitle}
          selectedColumns={selectedColumns}
          rows={rows}
          emptyMessage={
            reportResults ? "No matching policies found." : "Run the report to view results."
          }
          toolbar={toolbar}
          formatFieldName={formatFieldName}
        />
      </div>
    </>
  );
}

export default SoldPoliciesReportBuilder;